import { Outlet, createRootRoute } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'
import { Suspense, lazy } from 'react'
import { useAuth } from '@/lib/auth'
import { AppShell } from '@/components/AppShell'
import { SignInScreen } from '@/components/SignInScreen'

const DevtoolsInProd = () => null
const ShownDevtools = import.meta.env.DEV
  ? lazy(() => Promise.resolve({ default: TanStackRouterDevtools }))
  : DevtoolsInProd

function RootLayout() {
  const { user, initializing } = useAuth()
  if (initializing) {
    return (
      <div className="flex h-screen items-center justify-center text-sm text-zinc-500">
        Loading…
      </div>
    )
  }
  if (!user) return <SignInScreen />
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  )
}

export const Route = createRootRoute({
  component: () => (
    <>
      <RootLayout />
      <Suspense fallback={null}>
        <ShownDevtools />
      </Suspense>
    </>
  ),
})
